import { useQuery } from "@apollo/client";
import { forwardRef } from "react";

import { JOB_MANY } from "../../../schema/job";
import { Job } from "../../../types";
import { Error, Loading } from "../../ui/Alerts";

const JobSelect = forwardRef((props: any, ref: any) => {
  const { loading, error, data } = useQuery(JOB_MANY);

  if (loading) return <Loading />;
  if (error) return <Error error={error} />;

  return (
    <select
      {...props}
      ref={ref}
      autoComplete="type"
      className="mt-1 block w-full py-2 px-3 border border-gray-300 bg-white rounded-md shadow-sm focus:outline-none focus:ring-orange-500 focus:border-orange-500 sm:text-sm"
    >
      <option value=""></option>
      {data.jobMany.map((job: Job) => (
        <option key={job._id} value={job._id}>
          {job.name}
        </option>
      ))}
    </select>
  );
});

export default JobSelect;
